var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PreviewCustomer"},[_c('div',{staticClass:"box",style:({ 'background-image': `url(${_vm.backgroundImg || `../../assets/img/u9.png`})` })},[_c('img',{attrs:{"src":require('@/assets/img/guideShopshelf/card.png'),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }